"use client"

import { Rat } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `RatIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const RatIcon = component(Icon)({ as: Rat })
